import React, {useState, useEffect} from 'react'
import Api from '../servicios/api'
import {Link} from "react-router-dom"
import {Header, Titulo, ContenedorHeader, ContenedorBotones} from '../elementos/Header'
import Boton from '../elementos/Boton'
import {ContenedorBotonesLista, BotonEditar, BotonEliminar} from '../elementos/ElementosDeLista'
import {ReactComponent as IconoEditar} from '../imagenes/editar.svg'
import {ReactComponent as IconoBorrar} from '../imagenes/borrar.svg'
import Alerta from '../elementos/Alerta'
import Cargando from '../elementos/Cargando'
import VentanaModal from '../elementos/VentanaModal'
import BusquedaFecha from './BusquedaFecha'

const FiltrarVisitasDirectas = () => {
    let date = new Date();
    const [datosCargados, setdatosCargados] = useState(false);
    const [visitasDirectas, setVisitasDirectas] = useState([]);
    const [estadoAlerta, setEstadoAlerta] = useState(false);
    const [alerta, setAlerta] = useState({});
    const [estadoModal, setEstadoModal] = useState(false);
    const [modal, setModal] = useState({});
    const [idEliminar, setidEliminar] = useState();
    const [inputFechaInicio, setInputFechaInicio] = useState(date.getFullYear() + "-" + ('0' + (date.getMonth()+1)).slice(-2) + "-" + ('0' + 1).slice(-2));
    const [inputFechaFin, setInputFechaFin] = useState(date.getFullYear() + "-" + ('0' + (date.getMonth()+1)).slice(-2) + "-" + ('0' + ultimoDiaMes()).slice(-2));
    const [estadoBusqueda, setEstadoBusqueda] = useState(true);

    function ultimoDiaMes () {
        let date = new Date();
        let ultimoDia = new Date(date.getFullYear(), date.getMonth() + 1, 0);
        return ultimoDia.getDate();
    }

    //Este hook se ejecuta solamente al primer renderizado
    useEffect(() => {
        cargarDatos();
    }, [estadoBusqueda]);

    //Este hook se ejecuta solamente al primer renderizado
    const cargarDatos = () => {
        if(estadoBusqueda){
            var datosEnviar = {fechaInicio: inputFechaInicio, fechaFin:inputFechaFin}
            fetch(Api+"?consultarVisitasDirectas",{
                method:"POST",
                body:JSON.stringify(datosEnviar)
            })
            .then(respuesta=>respuesta.json())
            .then((datosRespuesta)=>{
                setdatosCargados(true)
                setVisitasDirectas(datosRespuesta)
            })
            .catch(console.log)
            setEstadoBusqueda(false)
        }
    }

    const handleChange = (e) => {
        switch(e.target.name){
            case 'fechaInicio':
                setInputFechaInicio(e.target.value);
                break;
            case 'fechaFin':
                setInputFechaFin(e.target.value);
                break;
            default:
                break;
        }
    }

    const handleModal = (id) => {
        setidEliminar(id);
        setEstadoModal(true);
        setModal({
            header: 'Eliminar Visita',
            body: '¿Está seguro de eliminar la visita?'
        });
    }

    const eliminarVisita = () => {
        setEstadoModal(false);
        setEstadoAlerta(false);
        setAlerta({});

        var datosEnviar = {id:idEliminar}
        fetch(Api+"?eliminarVisitaDirecta=1",{
            method:"POST",
            body:JSON.stringify(datosEnviar)
        })
        .then(respuesta=>respuesta.json())
        .then((datosRespuesta)=>{
            setEstadoAlerta(true);
            setAlerta({
                tipo: 'exito',
                mensaje: 'Visita eliminada.'
            });
            cargarDatos();
        })
        .catch(console.log)
    }

    if(!datosCargados){
        return(
            <Cargando />
        );
    }

    else{
        return (
            <>
                <Header>
                    <ContenedorHeader>
                        <Titulo>Visitas Directas</Titulo>
                        <ContenedorBotones>
                            <Boton to="/crear-visita-directa" primario="true">Registrar Visita</Boton>
                        </ContenedorBotones>
                    </ContenedorHeader>
                </Header>

                <BusquedaFecha
                        inputFechaInicio={inputFechaInicio}
                        inputFechaFin={inputFechaFin}
                        setEstadoBusqueda={setEstadoBusqueda}
                        handleChange={handleChange}
                        busqueda={Api+"ReporteVisitasDirectas.php?FechaInicio="+inputFechaInicio+"&FechaFin="+inputFechaFin}
                />
                
                <div className="contenedor-tabla">
                    <div className="card card-tamano card-tamano-fechas">
                        <div className="card-body">
                            <table className="table">
                                <thead>
                                    <tr>
                                        <th>Fecha Visita</th>
                                        <th>Nombres y Apellidos</th>
                                        <th>Cargo o Función</th>
                                        <th>Telefono</th>
                                        <th>Correo</th>
                                        <th>Opinión</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        visitasDirectas.success !== 0 &&
                                            visitasDirectas.map(
                                                (visita)=>(
                                                    <tr key={visita.Vis_ID}>
                                                        <td>{visita.Vis_Fecha}</td>
                                                        <td>{visita.Vis_Nombres}</td>
                                                        <td>{visita.Vis_Cargo}</td>
                                                        <td>{visita.Vis_Telefono}</td>
                                                        <td>{visita.Vis_Correo}</td>
                                                        <td>{visita.Vis_Opinion}</td>
                                                        <td>
                                                            <ContenedorBotonesLista>
                                                                <BotonEditar title="Actualizar Visita" as={Link} to={"/editar-visita/"+visita.Vis_ID}>
                                                                    <IconoEditar />
                                                                </BotonEditar>
                                                                
                                                                <BotonEliminar title="Eliminar Visita" onClick={() => handleModal(visita.Vis_ID)}>
                                                                    <IconoBorrar />
                                                                </BotonEliminar>
                                                            </ContenedorBotonesLista>
                                                        </td>
                                                    </tr>
                                                )
                                            )
                                    }
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>  
                    
                <Alerta 
                        tipo={alerta.tipo}
                        mensaje={alerta.mensaje}
                        estadoAlerta={estadoAlerta}
                        setEstadoAlerta={setEstadoAlerta}
                />

                <VentanaModal
                        mensajeHeader={modal.header}
                        mensajeBody={modal.body}
                        estadoModal={estadoModal}
                        setEstadoModal={setEstadoModal}
                        handleConfirm={eliminarVisita}
                />
            </>
        );
    }
}

export default FiltrarVisitasDirectas;